import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import {IconButton, Tooltip} from '@mui/material';
import {bool, func, string} from 'prop-types';
import React from 'react';

const ZoomToButton = ({onClick, tooltipText, disabled, ...props}) => {
  const adjustedButtonProps = {
    disabled: disabled,
    component: disabled ? 'div' : undefined,
    onClick: disabled ? undefined : onClick,
    sx: {
      '&.Mui-disabled': {
        pointerEvents: 'auto',
      },
    },
  };

  return (
    <Tooltip title={tooltipText}>
      <IconButton size="small" {...props} {...adjustedButtonProps}>
        <CenterFocusStrongIcon />
      </IconButton>
    </Tooltip>
  );
};

ZoomToButton.propTypes = {
  onClick: func,
  tooltipText: string,
  disabled: bool,
};

export default ZoomToButton;
